import { get, post } from "../../ApiService";
import { ApiUrl, BASE_URL } from "../../ApiUrl";

export interface SystemBanner {
  id: number;
  title: string;
  message: string;
  bannerContent?: string;
  type: string;
  priority: string;
  displayMode: string;
  targetType: string;
  startDate: string;
  endDate?: string;
  isActive: boolean;
  isDismissible: boolean;
  detailUrl?: string;
  projects?: any[];
  organizations?: any[];
  roles?: any[];
}

export const getActiveBanners = async () => {
  try {
    const response = await get(ApiUrl.systemBanners.activeBanners);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Marks a banner as read/dismissed on the server.
 * This will prevent the banner from being shown to this user again across devices and sessions.
 * 
 * @param bannerId The ID of the banner to mark as read
 * @returns Promise with the API response
 */
export const markBannerAsRead = async (bannerId: number) => {
  // Construct the URL for the mark_as_read endpoint
  const url = `${BASE_URL}/system-banners/${bannerId}/mark_as_read/`;
  // Send an empty object as data (required by post function)
  return await post(url, {});
};
